<template>
  <div class="oauth"></div>
</template>

<script>
import { getUserInfo } from "../api/common";
export default {
  name: "oauth",
  data() {
    return {};
  },
  mounted() {
    window.localStorage.setItem("userToken", this.$route.query.userToken);
    this.getPersonInfo(this.$route.query.userToken);
  },

  methods: {
    getPersonInfo(token) {
      let params = {
        token: token,
      };
      getUserInfo(params).then((res) => {
        window.localStorage.setItem("userId", res.data.userId);
        let str = this.$route.query.targetUrl;
        let index = str.lastIndexOf("/");
        let startUrl = str.substring(0, index);
        let endUrl = str.substring(index + 1, str.length);
        window.location.replace(startUrl + "/" + endUrl);
      });
    },
  },
};
</script>
<style scoped>
</style>
